import React from 'react';

const Tab4 = () => {
    return (
        <div>
            <div className='grid md:grid-cols-2 mt-20 mx-5'>
                <div>
                    <div className=' mb-20'>
                        <h3 className="text-sm font-semibold  tracking-widest mb-4 text-[#ff014f] uppercase">2020 - Present</h3>
                        <h1 className='text-4xl font-bold'>Marketplace Interview</h1>
                    </div>

                    <ol className="border-l-2 border-black">
                        <li>
                            <div className="md:flex flex-start">
                                <div className="bg-black w-6 h-6 flex items-center justify-center rounded-full -ml-3">
                                </div>
                                <div className="block p-6 w-full rounded-lg shadow-lg bg-[#212428] max-w-md ml-6 mb-10">
                                    <div className="flex justify-between mb-2">
                                        <a href="#!" className="font-font-semibold  hover:text-white focus:text-white duration-300 transition ease-in-out text-2xl">WordPress Developer</a>
                                    </div>
                                    <p href="#!" className="font-medium text-[#878E99] hover:text-white focus:text-white duration-300 transition ease-in-out text-lg mb-10">Fiverr </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div className="md:flex flex-start">
                                <div className="bg-black w-6 h-6 flex items-center justify-center rounded-full -ml-3">
                                </div>
                                <div className="block w-full p-6 rounded-lg shadow-lg bg-[#212428] max-w-md ml-6 mb-10">
                                    <div className="flex justify-between mb-2">
                                        <a href="#!" className="font-font-semibold  hover:text-white focus:text-white duration-300 transition ease-in-out text-2xl">Front End Developer</a>
                                    </div>
                                    <p href="#!" className="font-medium text-[#878E99] hover:text-white focus:text-white duration-300 transition ease-in-out text-lg mb-10">Upwork </p>
                                </div>
                            </div>
                        </li>
                    </ol>
                </div>
                <div>
                    <div className=' mb-20'>
                        <h3 className="text-sm font-semibold  tracking-widest mb-4 text-[#ff014f] uppercase">2021 - Present</h3>
                        <h1 className='text-4xl font-bold'>Job Interview</h1>
                    </div>

                    <ol className="border-l-2 border-black">
                        <li>
                            <div className="md:flex flex-start">
                                <div className="bg-black w-6 h-6 flex items-center justify-center rounded-full -ml-3">
                                </div>
                                <div className="block p-6 w-full rounded-lg shadow-lg bg-[#212428] max-w-md ml-6 mb-10">
                                    <div className="flex justify-between mb-2">
                                        <a href="#!" className="font-font-semibold  hover:text-white focus:text-white duration-300 transition ease-in-out text-2xl">Web Developer</a>
                                    </div>

                                    <p href="#!" className="font-medium text-[#878E99] hover:text-white focus:text-white duration-300 transition ease-in-out text-lg mb-10">Carikture Software Company </p>
                                </div>
                            </div>
                        </li>


                        <li>
                            <div className="md:flex flex-start">
                                <div className="bg-black w-6 h-6 flex items-center justify-center rounded-full -ml-3">
                                </div>
                                <div className="block w-full p-6 rounded-lg shadow-lg bg-[#212428] max-w-md ml-6 mb-10">
                                    <div className="flex justify-between mb-2">
                                        <a href="#!" className="font-font-semibold  hover:text-white focus:text-white duration-300 transition ease-in-out text-2xl">Virtual Assistant</a>
                                    </div>
                                    <p href="#!" className="font-medium text-[#878E99] hover:text-white focus:text-white duration-300 transition ease-in-out text-lg mb-10">Au Naturale Cosmetics </p>

                                </div>
                            </div>
                        </li>
                    </ol>
                </div>
            </div>
        </div>
    );
};

export default Tab4;